import validate from '../../../services/reduxValidate.js';

export default function (data) {
  return validate(data, {
    lastname: {
      presence: {allowEmpty: false}
    },
    email: {
      email: true,
      presence: {allowEmpty: false}
    },
    company: {
      presence: {allowEmpty: false}
    },
    tel: {
      presence: {allowEmpty: false},
      format: {
        pattern: /^\+?([0-9.\-\s]+)$/g,
        message: "Le numéro de téléphone est invalide"
      },
    },
    universe: {
      presence: {allowEmpty: false}
    }
  });
}